import React from 'react';
import { Outlet } from 'react-router-dom';

const AuditHistory = () => {
  return <Outlet />;
};

export default AuditHistory;
